import { SVGProps } from 'react';

const BookKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m19 3 1 1m0-2-4.5 4.5M14.344 2H6.5A2.5 2.5 0 0 0 4 4.5v15A2.5 2.5 0 0 0 6.5 22H19a1 1 0 0 0 1-1V7.898M4 19.5A2.5 2.5 0 0 1 6.5 17H20m-4-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default BookKey;
